import React from 'react';
import { useIntl } from 'react-intl-next';
import { selectionToolbarMessages } from '@atlaskit/editor-common/messages';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { PinIcon, PinnedIcon, ToolbarDropdownItem } from '@atlaskit/editor-toolbar';
var shouldShowPinMenuItem = function shouldShowPinMenuItem(editMode) {
  return editMode !== 'view';
};
/**
 * The menu-item version of pin only appears in selection toolbar - the primary toolbar will have its own component
 */
export var PinMenuItem = function PinMenuItem(_ref) {
  var api = _ref.api;
  var intl = useIntl();
  var editMode = useSharedPluginStateSelector(api, 'editorViewMode.mode');
  var toolbarDocking = useSharedPluginStateSelector(api, 'userPreferences.preferences.toolbarDockingPosition');
  var isToolbarDocked = toolbarDocking === 'top';
  if (!shouldShowPinMenuItem(editMode)) {
    return null;
  }
  var onClick = function onClick() {
    if (!api) {
      return;
    }
    if (isToolbarDocked) {
      var _api$selectionToolbar, _api$selectionToolbar2;
      (_api$selectionToolbar = api.selectionToolbar.actions) === null || _api$selectionToolbar === void 0 || (_api$selectionToolbar2 = _api$selectionToolbar.setToolbarDocking) === null || _api$selectionToolbar2 === void 0 || _api$selectionToolbar2.call(_api$selectionToolbar, 'none');
    } else {
      var _api$selectionToolbar3, _api$selectionToolbar4;
      (_api$selectionToolbar3 = api.selectionToolbar.actions) === null || _api$selectionToolbar3 === void 0 || (_api$selectionToolbar4 = _api$selectionToolbar3.setToolbarDocking) === null || _api$selectionToolbar4 === void 0 || _api$selectionToolbar4.call(_api$selectionToolbar3, 'top');
    }
  };
  var message = intl.formatMessage(isToolbarDocked ? selectionToolbarMessages.toolbarPositionPinedAtTop : selectionToolbarMessages.toolbarPositionUnpinnedConcise);
  return /*#__PURE__*/React.createElement(ToolbarDropdownItem, {
    onClick: onClick,
    elemBefore: isToolbarDocked ? /*#__PURE__*/React.createElement(PinnedIcon, {
      label: ""
    }) : /*#__PURE__*/React.createElement(PinIcon, {
      label: ""
    })
  }, message);
};